// ABOUTME: Centralized storage keys for localStorage operations
// ABOUTME: Provides type-safe access to all localStorage keys used in the application

export const STORAGE_KEYS = {
  // Auth
  SESSION_TOKEN_2: "x-session-token2",
  COOKIE_SUPPORT: "x-session-cookie-support",
  KRATOS_SESSION_TOKEN: "kratos_session_token",
  BIND_TRAINER_LINK: "bindTrainerLink",
  ROLE: "role",

  // UI State
  SIDEBAR_OPEN: "isOpenSidebar",
  WEEK_AMOUNT: "week",
  TYPE_CALENDAR: "typeCalendar",
  LIBRARY_VIEW_MODE: "library-trainings-view-mode",
  WEEK_SUMMARY_COLLAPSED: "weekSummaryCollapsed",
  LEFT_SIDEBAR_WIDTH: "AGILE_SPORT_PLAN_LEFT_SIDEBAR_WIDTH",
  RIGHT_SIDEBAR_WIDTH: "AGILE_SPORT_PLAN_RIGHT_SIDEBAR_WIDTH",

  // User Preferences
  ATHLETE_ID: "athleteID",
  LANGUAGE: "i18nextLng",
  // Colour theme of this device (shared/theme/theme.ts). index.html reads it too, before the bundle runs.
  THEME: "te.theme",
  LAP_COLUMN_SETTINGS: "lapColumnSettings",
  LAP_BLOCKS_COLLAPSED: "lapBlocksCollapsed",
  LAP_COMPARISON_MIN_MAX: "lapComparisonMinMax",
  LAP_COMPARISON_GROUPING: "lapComparisonGrouping",

  // Apple Health import
  HEALTH_IMPORTED_WORKOUTS: "appleHealth:importedWorkoutIds",
  HEALTH_PENDING_ACTIVITY_LINKS: "appleHealth:pendingActivityLinks",

  // Per-screen preferences
  ATHLETES_TYPE_RENDER: "athletes_typeRender",
  ATHLETES_FILTER: "athletes_filterSelect",
  STATISTICS_ATHLETE_ID: "statisticsAthleteId",
  STATISTICS_CHARTS: "te_statistics_charts_v2",
  WORKOUT_ANALYSIS_HIDDEN_PARAMS: "workout-analysis-hidden-params",
  WORKOUT_ANALYSIS_CHART_MODE: "workout-analysis-chart-mode",
  WORKOUT_ANALYSIS_MAP_POSITION: "workout-analysis-map-position",
  WORKOUT_ANALYSIS_MAP_GRADIENT: "workout-analysis-map-gradient",
  WORKOUT_CONSTRUCTOR_TASKS_PINNED: "workoutConstructor.tasksPinned",

  // Lactometer auto-import
  LACTATE_AUTO_IMPORTED_KEYS: "lactate:autoImportedKeys",

  // TE store: the cart's Vendure session off a .ru host (model/store/cartTokenStore.ts)
  STORE_CART_TOKEN: "te-cart-session",

  // Infrastructure
  APOLLO_CACHE_BACKUP: "apollo-cache-v2-backup",
  CHUNK_ERROR_RELOAD: "chunk_error_reload_timestamp",

  // Debug
  DEBUG_BLUETOOTH: "DEBUG_BLUETOOTH",
} as const

/**
 * Key families: a namespace registers a prefix instead of every key under it.
 * The VO2max calculator tabs keep one key per input (`vo2maxCalc:<tab>:<field>`).
 */
export const STORAGE_KEY_NAMESPACES = {
  VO2MAX_CALC: "vo2maxCalc:",
} as const

/**
 * sessionStorage keys shared between modules (per tab, gone when it closes).
 * A key read and written inside one module stays a constant of that module.
 */
export const TAB_STORAGE_KEYS = {
  /** Language picked on the auth screen, forwarded into the app as ?lang after login. */
  AUTH_SELECTED_LANG: "auth_selected_lang",
} as const

export type StorageKey =
  | (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS]
  | `${typeof STORAGE_KEY_NAMESPACES.VO2MAX_CALC}${string}`
